import { createContext, useContext } from 'react';

import type { OrderHistoryContextValue } from 'pages/orders/order_history/OrderHistory';

export const OrderHistoryContext = createContext({} as OrderHistoryContextValue);
OrderHistoryContext.displayName = 'OrderHistoryContext';

export const useOrderHistory = () => useContext(OrderHistoryContext);
